"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _util = require("../../util");
var Header = function Header(_ref) {
  var productType = _ref.productType;
  if (productType === _util.PRODUCT_TYPE_ABBR.INSTALLMENT_LOAN) return null;
  var bem = (0, _util.bemClass)('revision-offers');
  var _getTitle = getTitle(productType),
    text = _getTitle.text,
    type = _getTitle.type;
  return /*#__PURE__*/_react.default.createElement("h2", {
    className: bem('header')
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: bem('header', 'header-text')
  }, text), /*#__PURE__*/_react.default.createElement("span", {
    className: bem('header', 'header-bank-name')
  }, type));
};
Header.propTypes = {
  productType: _propTypes.default.string.isRequired
};
function getTitle(productType) {
  if (_util.ADS_PRODUCTS.includes(productType)) return {
    text: 'Revolving lines of credit',
    type: ' with Comenity Capital Bank'
  };
  if (_util.LC_PRODUCTS.includes(productType)) return {
    text: 'Fixed Installment Loans',
    type: ' with LendingClub Bank'
  };
  return {
    text: '',
    type: ''
  };
}
var _default = Header;
exports.default = _default;
